var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#logo',
                        view: publicPath + 'sprite.svg#view-logo',
                        viewBox: '0 0 422 117',
                        title: 'logo',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };